import { createContext, useContext } from 'react';

import type { NameAccessor } from '../types/treemap.js';

export const NameAccessorContext = createContext<NameAccessor | undefined>(
  undefined,
);

export const useNameAccessor = () => useContext(NameAccessorContext);

NameAccessorContext['displayName'] = 'NameAccessorContext';
